import { QuestionSkeleton } from '@/components/question-card-skeleton';
import { Suspense } from 'react';
import '../styles/prose-mirror.css';

interface RichTextContentProps {
  title?: string;
  description?: string | null;
}

function RichTextContent({ description }: { description: string }) {
  return (
    <div
      className="prose prose-sm text-xs lg:text-sm max-w-none ProseMirror break-words"
      dangerouslySetInnerHTML={{
        __html: description,
      }}
    />
  );
}

export function RichTextContentViewer({
  title,
  description,
}: RichTextContentProps) {
  return (
    <>
      {title && (
        <div
          className="text-base font-medium text-wrap break-words "
          dangerouslySetInnerHTML={{
            __html: title,
          }}
        />
      )}

      {description && (
        <Suspense fallback={<QuestionSkeleton />}>
          <RichTextContent description={description} />
        </Suspense>
      )}
    </>
  );
}
